import { render, staticRenderFns } from "./CameraPageShootCardDiagonalHeader.vue?vue&type=template&id=6f9df0d9&scoped=true&"
import script from "./CameraPageShootCardDiagonalHeader.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardDiagonalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootCardDiagonalHeader.vue?vue&type=style&index=0&id=6f9df0d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9df0d9",
  null
  
)

export default component.exports